import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

interface ExtendSessionResponse {
  authenticated: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class SessionTimerService {
  constructor(private http: HttpClient) {}

  public extendSession(): Observable<
    ExtendSessionResponse | HttpErrorResponse
  > {
    const endpoint = '/user/keep-alive/';

    return this.http.get<ExtendSessionResponse>(endpoint);
  }
}
